import React, {useEffect} from 'react';

const FlashMessage = ({
  show, hideCallback = () => {}, duration = 2000, children,
}) => {
  // Intentionally leaves out hideCallback dependency as this shouldn't change
  // over lifespan of FlashMessage
  useEffect(() => {
    if (duration && show) setTimeout(hideCallback, duration);
  }, [duration, show]);

  return (
    <div style={{opacity: show ? 1 : 0, transition: 'opacity 1s'}}>
      {children}
    </div>
  );
};

export default FlashMessage;
